import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * DateInput - simple native date input wrapped in MUI TextField.
 * Uses input type="date" for broad compatibility without extra dependencies.
 */
const DateInput = ({
    label,
    value = "",
    onChange,
    name,
    required = false,
    disabled = false,
    error = false,
    helperText = "",
    min = "",
    max = "",
    disablePast = false,
    inputProps = {},
    ...rest
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const today = new Date().toISOString().split("T")[0];
    const finalMin = disablePast ? today : min || undefined;

    const handleChange = (e) => {
        if (!onChange) return;
        onChange({
            target: {
                name: name || "",
                value: e.target.value,
            },
        });
    };

    return (
        <TextField
            type="date"
            fullWidth
            label={label}
            value={value}
            onChange={handleChange}
            name={name}
            required={required}
            disabled={disabled}
            error={error}
            helperText={helperText}
            InputLabelProps={{ shrink: true }}
            inputProps={{
                min: finalMin,
                max: max || undefined,
                ...inputProps,
            }}
            sx={{
                direction: isArabic ? "rtl" : "ltr",
                "& .MuiInputLabel-root": {
                    left: isArabic ? "auto" : undefined,
                    right: isArabic ? "1.75rem" : undefined,
                    transformOrigin: isArabic ? "right" : "left",
                },
            }}
            {...rest}
        />
    );
};

export default DateInput;
